import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_LOADING,
  SET_HUB_INFO,
  SET_MERCHANT_INFO,
  SET_SHOP_INFO,
  SET_CUSTOMER_INFO,
  SET_CORPORATE_INFO,
  SET_CATEGORY_INFO,
  SET_CAMPAIGN_INFO,
  SET_DRIVER_INFO,
  SET_FEEDBACK_INFO,
  LOGOUT,
} from "./authType";

const initialState = {
  name: "",
  email: "",
  role: "",
  exp: null,
  error: false,
  success: false,
  loading: false,
  hubInfo: {
    id: "",
    name: "",
    image: "",
    type: "",
    deleted: "",
  },
  merchantInfo: {
    id: "",
    name: "",
    image: "",
    phone: "",
    email: "",
    deleted: "",
    merchantId: "",
  },
  shopInfo: {
    id: "",
    name: "",
    type: "",
    mobileNumber: "",
    rating: null,
    logo: "",
    banner: "",
    status: "",
    hubId: "",
    deleted: "",
  },
  driverInfo: {
    image: "",
    name: "",
    rating: null,
    balance: "",
    mobileNumber: "",
  },
  customerInfo: {
    image: "",
    fullName: "",
    rating: null,
    balance: "",
    mobileNumber: "",
    profilePicture: "",
  },
  corporateInfo: {
    id: "",
    ownerId: "",
    image: "",
    name: "",
    balance: "",
    isActive: "",
  },
  categoryInfo: {
    title: "",
    slug: "",
    type: "",
    id: "",
    image: "",
    bannerImage: "",
  },
  campaignInfo: {
    name: "",
    colorCode: "",
    type: "",
    id: "",
    banner: "",
    bannerWeb: "",
  },
  feedbackInfo: {
    customerName: "",
    customerImage: "",
    customerContact: "",
    id: "",
    customerType: "",
  },
};

const authRedcer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST: {
      state.loading = true;
      return state;
    }
    case LOGIN_SUCCESS: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }
    case LOGIN_LOADING: {
      return state;
    }

    case SET_HUB_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }

    case SET_MERCHANT_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }

    case SET_SHOP_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }

    case SET_CORPORATE_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }

    case SET_CATEGORY_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }

    case SET_CAMPAIGN_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }

    case SET_CUSTOMER_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }
    case SET_DRIVER_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }
    case SET_FEEDBACK_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }

    case LOGOUT: {
      state = { ...state, token: null, ...action.payload };
      return state;
    }

    default: {
      state.loading = false;
      return state;
    }
  }
};

export default authRedcer;
